
export class UserTypeEnum {
    public static readonly Person = 1;
    public static readonly System = 2;
    public static readonly TopBarLogo = 3;
    public static readonly MainLogo = 4;

    
}















